import { cmsConstants } from '../../../constants/cms/cms.constants';
import { authHeader } from '../../../helpers/authHeader';
import { handleResponse } from '../../../helpers/handleresponse';

export const cmsActions = {
    setSourceLocation,
    setEnviroment,
    containerToUpdate,
    containerUpdated,
    containerAdded,
    loadClientFonts,
    getClientFonts,
    getFonts,
    removeFont,
    addFont,
    alertNewModifications,
    globalSavingLoader,
    toggleInheritageInfo,
    inheritageAffected,
    blockDeselect
}


function globalSavingLoader(isLoading) {
    return dispatch => {
        dispatch(success(isLoading));
    };
    function success(model) {
        return { type: cmsConstants.GLOBAL_SAVING_LOADER, isLoading};
    }
}
function blockDeselect(isBlocked) {
    return dispatch => {
        dispatch(success(isBlocked));
    };
    function success(model) {
        return { type: cmsConstants.BLOCK_DESELECT, isBlocked};
    }
}

function alertNewModifications(isModified, source, callback) {

    return dispatch => {
        dispatch(success(isModified, source, callback));
    };
    function success(model) {
        return { type: cmsConstants.ALERT_NEW_MODIFICATIONS, isModified, source, callback };
    }
}

function loadClientFonts(fonts) {
    return dispatch => {
        dispatch(success(fonts));
    };
    function success(fonts) {
        return { type: cmsConstants.LOAD_CLIENT_FONTS, fonts };
    }
}
function removeFont(font) {
    return dispatch => {
        dispatch(success(font));
    };
    function success(font) {
        return { type: cmsConstants.REMOVE_CLIENT_FONT, font };
    }
}
function addFont(font) {
    return dispatch => {
        dispatch(success(font));
    };
    function success(font) {
        return { type: cmsConstants.ADD_CLIENT_FONT, font };
    }
}


function inheritageAffected(isAffected){
    return dispatch => {
        dispatch(success(isAffected));
    };
    function success(isAffected) {
        return { type: cmsConstants.INHERITAGE_AFFECTED, isAffected };
    }
}
function toggleInheritageInfo(on){
    return dispatch => {
        dispatch(success(on));
    };
    function success(on) {
        return { type: cmsConstants.TOGGLE_INHERITAGE_INFO, on };
    }
}
function getClientFonts(eventId) {
    return dispatch => {
        const requestOptions = {
            method: "GET",
            headers: authHeader({ "Content-Type": "application/json" }),
        };
        fetch(`./api/files/fonts/${eventId}`, requestOptions)
            .then(handleResponse)
            .then(data => {
                if (data.files !== undefined) {
                    let clientFonts = [];
                    data.files.map(f => {

                        clientFonts.push({
                            name: f.name.substring(f.name.lastIndexOf('/') + 1, f.name.lastIndexOf('.') + 1).toString()
                                .replace(')', '')
                                .replace('(', '').replace('.', '').replace('1', '').replace('', ''), url: f.url
                        });
                    });
                    dispatch(success(clientFonts));
                }

            })
    };
    function success(fonts) {
        return { type: cmsConstants.LOAD_CLIENT_FONTS, fonts };
    }
}
function getFonts(eventId) {

    return dispatch => {
        const requestOptions = {
            method: "GET",
            headers: authHeader({ "Content-Type": "application/json" }),
        };
        fetch(`./api/files/?format=font`, requestOptions)
            .then(handleResponse)
            .then(data => {
                let clientFonts = [];
                if (data.files === undefined) { return; }
                data.files.map(f => {

                    /*  fonts.push(this.convertFont(f.name)); */
                    clientFonts.push({
                        name: f.name.substring(f.name.lastIndexOf('/') + 1, f.name.lastIndexOf('.') + 1).toString()
                            .replace(')', '')
                            .replace('(', '').replace('.', '').replace('1', '').replace('', ''), url: f.url
                    });
                });
                dispatch(success(clientFonts));

            })
    };

    /*  function success(font) {
         return { type: cmsConstants.ADD_CLIENT_FONT, font };
     } */
    function success(fonts) {
        return { type: cmsConstants.LOAD_CLIENT_FONTS, fonts };
    }

}


//Remove these?
function containerToUpdate(container) {
    return dispatch => {
        dispatch(success(container));
    };
    function success(container) {
        return { type: cmsConstants.CONTAINER_TO_UPDATE, container };
    }
}
function containerUpdated() {
    return dispatch => {
        dispatch(success());
    };
    function success() {
        return { type: cmsConstants.CONTAINER_UPDATED };
    }
}
function containerAdded(container) {
    return dispatch => {
        dispatch(success(container));
    };
    function success(container) {
        return { type: cmsConstants.CONTAINER_ADDED, container };
    }
}


function setEnviroment(env, editMode = false, eventId) {
    return dispatch => {
        dispatch(success(env, editMode));
    };
    function success(env) {
        return { type: cmsConstants.SET_ENVIROMENT, env, editMode, eventId };
    }
}

function setSourceLocation(sourceLoc, env) {
    return dispatch => {
        dispatch(success(sourceLoc, env));
    };
    function success(sourceLoc, env) {
        return { type: cmsConstants.SET_SOURCE_LOCATION, sourceLoc, env };
    }
}
